import { render, staticRenderFns } from "./PageTop.vue?vue&type=template&id=4f97f6da&scoped=true&"
import script from "./PageTop.vue?vue&type=script&lang=js&"
export * from "./PageTop.vue?vue&type=script&lang=js&"
import style0 from "./PageTop.vue?vue&type=style&index=0&id=4f97f6da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97f6da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Animation: require('/vercel/path0/components/Animation.vue').default,HeroAlternative: require('/vercel/path0/components/HeroAlternative.vue').default,Hero: require('/vercel/path0/components/Hero.vue').default,Standfirst: require('/vercel/path0/components/Standfirst.vue').default})
